export default __webpack_public_path__ + "static/media/cp_geo_pf.2c14ae64.svg";